import React from "react"

import { ContentWrapper } from "../elements"

export const Content = ({ children, spacing }) => {
  return <ContentWrapper spacing={spacing} className="contwrap">{children}</ContentWrapper>
}
